var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-component d-flex"},_vm._l((this.options),function(option){return _c('div',{key:option.id,staticClass:"single-question-item",class:{
            active: _vm.isSelected(option.id),
            'not-selected': !_vm.isSelected(option.id),
        },on:{"click":function($event){return _vm.updateInputValue(option.id)}}},[_c('div',{staticClass:"marker"}),_vm._v(" "),(_vm.isSelected(option.id))?_c('i',{staticClass:"icon-cr icon-btn-true"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"item-text text-uppercase"},[_vm._v(_vm._s(option.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }